import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeCitations',
  standalone: false,
})
export class RemoveCitationsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || !value.replace) {
      return value;
    }
    return value.replace(/<citation\b[^>]*>.*?<\/citation>/g, '');
  }
}
